import { message, QRCode } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { shareIcon } from '../../assets';

import { IAsset } from '../../pages/Wallet/types';
import { copyToClipboard } from '../../utils/helper';

import Modal from '../Modal/Modal';
import './Deposit.scss';
import Button from '../Button/Button';

const Deposit: React.FC<{
    closeBtn?: Function;
    deposit: IAsset;
    asseId: number;
}> = ({ closeBtn, deposit }) => {
    const { t } = useTranslation();

    return (
        <>
            {deposit.address && (
                <Modal closeBtn={closeBtn}>
                    <div className="deposit">
                        <div className="deposit__title">
                            <h1>
                                {t('wallet.deposit.title')} {deposit.assetId === 1 ? 'USDT' : 'MELLSTROY'}
                            </h1>
                            <p>{t('wallet.deposit.text')}</p>
                        </div>
                        <div className="qr">
                            <QRCode value={deposit.address} />
                            <p className="qr-text">{deposit?.address}</p>
                        </div>

                        <div className="deposit__btns">
                            <Button
                                title={t('btns.copy')}
                                onClick={() => {
                                    deposit?.address && copyToClipboard(deposit.address);
                                    message.success('Адрес скопирован');
                                }}
                            />
                            <Button
                                icon={shareIcon}
                                onClick={() => {
                                    if (navigator.share) {
                                        navigator
                                            .share({
                                                text: deposit.address,
                                            })
                                            .then(() => console.log('Successful share'))
                                            .catch((error) => console.log('Error sharing:', error));
                                    }
                                }}
                            />
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default Deposit;
